<template>
  <nav
    :class="{
      'opened': opened,
      'dark': darkMode,
    }"
    @click.self="$emit('switch-toggle')"
  >
    <div class="nav-wrap" @scroll.passive="handleScroll">
      <div class="nav-container">
        <router-link class="nav-item" to="/" exact>
          <fps-icon class="icon" type="home" size="24" />首頁
        </router-link>
        <router-link class="nav-item" to="/quick-order">
          <fps-icon class="icon" type="quick-order" size="24" />極速約單
        </router-link>
        <callPhoneNavVue></callPhoneNavVue>
         <!-- <router-link class="nav-item" to="/anonymous-call">
          <img
            class="title-icon"
            src="~@/assets/image/icons/icon-mask-dark.png"
            alt=""
            srcset=""
            v-if="$route.meta && $route.meta.darkMode"
          />
          <img
            class="title-icon"
            src="~@/assets/image/icons/icon-mask.png"
            alt=""
            srcset=""
            v-else
          />匿名熱線
        </router-link> -->
        <router-link class="nav-item" to="/feed-list">
          <fps-icon class="icon" type="find" size="24" />動態
          <i class="has-new" v-if="$store.state.app.hasFeedFollow"></i>
        </router-link>
       
        <voice-room-list></voice-room-list>
        <template v-if="userInfo&&recommentGames">
            <div class="split no-margin-top"></div>
            <div class="title">
              常用技能
              <div class="handle" @click.prevent.stop="$router.push('/skill-list')">
                <div class="more">
                  <fps-icon class="more" type="more" size="20" />
                </div>
              </div>
            </div>
            <template v-if="recommentGames.length">
              <router-link
                class="nav-item"
                v-for="item in recommentGames"
                :key="item.id"
                :to="`/player-list/${item.id}`"
                :replace="$route.name === 'playerList'"
              >
                <div class="image game">
                  <img :src="item.imageUrl + '?d=100x100'" />
                  <span class="recent-tag" v-if="item.recentOrder">最近下單</span>
                </div>
                <div class="name">{{ item.name }}</div>
              </router-link>
              <!-- <nav-item
                v-for="(item, index) in recommentGames"
                :key="item.id"
                :item="item"
                :is-mine="true"
                :active="menuIndex == index"
                :darkMode="darkMode"
                @handle="openMenu($event, index)"
              /> -->
            </template>
            <div 
              class="add-skill-button"
              :class="{'dark-add-skill': darkMode}"
              @click.prevent.stop="$router.push('/skill-list')">{{hasAddAllCustom ? '全部技能':'添加技能' }}
            </div>
        </template>
        <template v-else>
          <div class="split no-margin-top"></div>
          <div class="title">
            熱門技能
          </div>
          <template v-if="allGameCustomList">
            <router-link
              class="nav-item"
              v-for="item in allGameCustomList.slice(0,6)"
              :key="item.id"
              :to="`/player-list/${item.id}`"
              :replace="$route.name === 'playerList'"
            >
              <div class="image game">
                <img :src="item.imageUrl + '?d=100x100'" />
              </div>
              <div class="name">{{ item.name }}</div>
            </router-link>
            <!-- <nav-item
              v-for="(item, index) in recommentGames"
              :key="item.id"
              :item="item"
              :is-mine="true"
              :active="menuIndex == index"
              :darkMode="darkMode"
              @handle="openMenu($event, index)"
            /> -->
          </template>
        </template>
        <template v-if="myOrders.length">
          <div class="split"></div>
          <div class="title">最近下單</div>
          <router-link
            class="nav-item"
            v-for="item in myOrders"
            :key="item.orderTime"
            :to="`/player-detail/${item.masterUuid}`"
          >
            <div class="image avatar">
              <fps-avatar :src="item.avatarUrl" />
              <div v-if="$util.isOnline(item)" class="online-status"></div>
            </div>
            <div class="name">{{ item.nickname }}</div>
          </router-link>
           <div class="see-more" v-if="originMyOrders.length>3" @click="getMyOrders">
             {{moreOrders ?'查看更多':'收起'}}
             
           </div>
        </template>
      </div>
      <!-- 通用底部 -->
      <layout-footer
        class="footer"
        :is-nav="true"
        :dark-mode="darkMode"
        @echat="$emit('echat')"
      />
    </div>
    <div class="menu" :style="{ top: menuTop + 'px' }">
      <div data-nav-handle="1" class="menu-item" @click="openSettingSkill">設定</div>
    </div>
    <!-- 设置常用技能 -->
    <dialog-setting-skill
      v-model="settingSkill"
    />
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutFooter from './footer'
import DialogSettingSkill from './setting-skill'
import VoiceRoomList from '@/components/VoiceRoom/component/voice-room-list.vue';
import callPhoneNavVue from '@/components/AnonymousCall/call-phone-nav.vue'

export default {
  components: {
    LayoutFooter,
    DialogSettingSkill,
    'voice-room-list': VoiceRoomList,
    callPhoneNavVue
  },
  data() {
    return {
      loading: false,
      menuTop: -100,
      scrollTop: 0,
      timer: null,
      myOrders: [], // 要展示的最近下单
      navigators: [],
      settingSkill: false,
      originMyOrders: [], // 所有最近下单總值 10
      recommentGames: []
    }
  },
  props: {
    opened: {
      type: Boolean,
      default: true
    },
    darkMode: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters(['userInfo', 'allGameCustomList', 'myGames']),
    // 是B端用户
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player'
    },
    myUuid() {
      return this.userInfo ? this.userInfo.uuid : ''
    },
    moreOrders() {
      return this.myOrders.length < this.originMyOrders.length
    },
    // 常用技能是否滿
    hasAddAllCustom() {
      return this.recommentGames.length >= 10
    }
  },
  watch: {
    myUuid(uuid) {
      if (uuid) {
        this.initMyData()
      } else {
        this.myOrders = []
        this.navigators = []
      }
      this.$store.dispatch('app/getGamesList')
    },
    myGames() {
      this.initRecomment()
    },
  },
  created() {
    if (this.userInfo) {
      this.initMyData()
    }
  },
  methods: {
    getMyOrders() {
      let max = this.originMyOrders.length
      // 當前長度
      let cl = this.myOrders.length
      if(cl===max && max > 3) {
        this.myOrders = this.originMyOrders.slice(0, 3)
      } else {
        this.myOrders = this.originMyOrders
      }
    },
    initMyData() {
      this.$http.get('/user/recent/master').then(({ data }) => {
        this.originMyOrders = data || []
        this.myOrders = (data || []).slice(0, 3)
      })
      this.$http.get('/navigation/list').then(({ data }) => {
        this.navigators = data ? data.filter(item => {
          return item.recommendType === 'SKILL_LIST'
        }) : []
      })
      this.initRecomment()
    },
    initRecomment() {
      this.$http.get('/game/userCustom/get/v2').then(({ data }) => {
        this.recommentGames = data.userCustomGames || []
        if(this.recommentGames.length > 10) {
          this.recommentGames = this.recommentGames.slice(0, 10)
        }
      })
    },
    concatus() {
      if (this.userInfo) {
        this.openChat()
      } else {
        this.$util.Login().then(() => {
          this.openChat()
        })
      }
    },
    openChat() {
      this.$util.openChatWindow(this.myUuid)
    },
    openMenu(event) {
      const { offsetTop } = event.target
      this.menuTop = offsetTop - this.scrollTop
      setTimeout(() => {
        const hideNavItemMenu = () => {
          this.menuTop = -100
          document.removeEventListener('click', hideNavItemMenu)
        }
        document.addEventListener('click', hideNavItemMenu)
      }, 100)
    },
    handleScroll(event) {
      const { scrollTop } = event.target
      this.scrollTop = scrollTop
      if (this.timer || (this.menuTop == -100)) return
      this.timer = setTimeout(() => {
        this.menuTop = -100
        this.timer = null
      }, 300)
    },
    openSettingSkill() {
      this.settingSkill = true
    },
  }
}
</script>

<style lang="scss" scoped>
  $width-nav: 220px;
  $split-dark: #313F5C;
  nav {
    flex-shrink: 0;
    box-sizing: content-box;
    position: relative;
    width: $width-nav;
    height: 100%;
    transform: translateX(-$width-nav);
    transition: transform 0.3s linear;
    > * {
      width: 100%;
      flex-grow: 1;
      background: #fff;
    }
    &.opened {
      transform: translateX(0);
    }
    .nav-wrap {
      position: relative;
      height: 100%;
      padding-top: 12px;
      overflow-y: auto;
      @include hideScrollBar(0, 0);
      .nav-container {
        min-height: calc(100% - 91px);
      }
      .link {
        padding: 15px 0 30px 20px;
        line-height: 20px;
        a {
          color: $color-gray-3;
          font-size: 14px;
          &:hover {
            color: $color-gray-2;
          }
        }
      }
    }
    .menu {
      position: absolute;
      left: 100%;
      top: 10px;
      transform: translateX(-7px);
      width: 88px;
      height: auto;
      padding: 8px;
      border: 1px solid $color-split;
      box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      &-item {
        height: 36px;
        padding: 8px;
        line-height: 20px;
        color: $color-gray-1;
        font-size: 14px;
        border-radius: 6px;
        cursor: pointer;
        &:hover {
          background: $color-split;
        }
      }
    }
    .nav-item {
      @include flex(flex-start);
      position: relative;
      height: 56px;
      padding: 0 10px 0 24px;
      color: $color-gray-1;
      font-size: 14px;
      &:hover {
        background: rgba($color: $color-split, $alpha: 0.4);
      }
      &.router-link-active {
        background: rgba($color: $color-split, $alpha: 0.7);
      }
      .icon {
        margin: 0 20px 0 8px;
      }
      .image {
        flex-shrink: 0;
        position: relative;
        width: 32px;
        height: 32px;
        margin-left: 5px;
        img {
          width: 100%;
          height: 100%;
          overflow: hidden;
          border-radius: 4px;
        }
      }
      .title-icon {
        width: 24px;
        height: 24px;
        margin: 0 20px 0 8px;
      }
      .recent-tag {
        position: absolute;
        bottom: -14px;
        left: 50%;
        height: 28px;
        width: 88px;
        transform: translate(-50%, 0) scale(0.5);
        text-align: center;
        line-height: 28px;
        color: #ffffff;
        background: #8C94AA;
        border-radius: 2px;
      }
      .name {
        margin-left: 15px;
        @include ellipsis(2);
      }
      .online-status {
        position: absolute;
        z-index: 10;
        right: -1px;
        bottom: 0;
        width: 10px;
        height: 10px;
        border: 2px solid #fff;
        border-radius: 100%;
        background: $color-green;
      }
    }
    .split {
      height: 1px;
      background-color: $color-button;
      margin: 12px 0 0;
      &.no-margin-top {
        margin-top: 0
      }
    }
    .title {
      @include flex(space-between);
      padding: 24px 0 6px 24px;
      line-height: 24px;
      color: $color-gray-3;
      font-size: 14px;
      font-weight: 500;
      .handle {
        width: 24px;
        height: 24px;
        margin-right: 24px;
        opacity: 0.4;
        .more {
          @include flex;
          width: 100%;
          height: 100%;
          color: $color-gray-3;
          border-radius: 4px;
          cursor: pointer;
          &:hover {
            opacity: 1;
            background: rgba($color: #E8EAEE, $alpha: 0.7);
          }
        }
      }
      &:hover {
        .handle {
          opacity: 1;
          .more {
            opacity: 0.6;
          }
        }
      }
    }
    .setting {
      padding: 20px 24px;
      line-height: 20px;
      color: $color-gray-1;
      font-size: 14px;
      button {
        @include flex;
        margin-top: 12px;
        width: 110px;
        height: 32px;
        border: 2px solid $color-button;
        border-radius: 20px;
        color: $color-gray-1;
        &:hover {
          background-color: $color-light;
        }
      }
    }
    .footer {
      border-top: 1px solid $color-button;
    }
    &.dark {
      > * {
        background: $color-gray-1;
      }
      .nav-wrap {
        .link a {
          color: $color-gray-2;
        }
      }
      .menu {
        border: 1px solid $split-dark;
        &-item {
          color: $color-gray-3;
          &:hover {
            background: rgba($color: $color-split, $alpha: 0.1);
          }
        }
      }
      .nav-item {
        color: $color-gray-3;
        &:hover {
          background: rgba($color: $color-split, $alpha: 0.1);
        }
        &.router-link-active {
          background: rgba($color: $color-split, $alpha: 0.08);
        }
      }
      .split {
        background-color: $split-dark;
      }
      .title {
        color: $color-gray-2;
        .handle .more {
          &:hover {
            background: rgba($color: $color-split, $alpha: 0.2);
            color: $color-gray-1;
          }
        }
      }
      .setting {
        color: $color-gray-3;
        button {
          border: 2px solid $color-gray-2;
          color: $color-gray-3;
          &:hover {
            color: #fff;
            background-color: $color-gray-2;
          }
        }
      }
      .footer {
        border-top: 1px solid $split-dark;
      }
    }
  }
  .see-more {
    padding: 15px 0 30px 20px;
    line-height: 20px;
    color: $color-gray-3;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      color: $color-gray-2;
    }
  }
  @media screen and (max-width: 599px) {
    nav {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba($color: #000, $alpha: 0.6);
      margin-left: 0;
      transform: translateX(-100%);
      > * {
        width: 61.8vw;
        margin-left: -61.8vw;
        transition: margin-left 0.3s;
      }
      &.opened {
        transform: translateX(0);
        > * {
          margin-left: 0;
        }
      }
      .menu {
        left: 61.8vw;
      }
    }
  }
  .has-new {
    display: block;
    position: absolute;
    top: 16px;
    left: 110px;
    width: 8px;
    height: 8px;
    background: #E63B37;
    border-radius: 50%;
  }
  .add-skill-button {
    width: 192px;
    height: 40px;
    margin: 16px auto 24px;
    text-align: center;
    background: #F1F4F6;
    border-radius: 50px;
    color: #636D86;
    line-height: 40px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
  }
  .dark-add-skill {
    background: #8C94AA;
    color: #222C43;
  }
</style>
